/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ServiceItemBreadcrumbsInner
 */
export interface ServiceItemBreadcrumbsInner {
  /**
   *
   * @type {string}
   * @memberof ServiceItemBreadcrumbsInner
   */
  title: string
  /**
   *
   * @type {string}
   * @memberof ServiceItemBreadcrumbsInner
   */
  slug: string
}

/**
 * Check if a given object implements the ServiceItemBreadcrumbsInner interface.
 */
export function instanceOfServiceItemBreadcrumbsInner(
  value: object
): value is ServiceItemBreadcrumbsInner {
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('slug' in value) || value['slug'] === undefined) return false
  return true
}

export function ServiceItemBreadcrumbsInnerFromJSON(
  json: any
): ServiceItemBreadcrumbsInner {
  return ServiceItemBreadcrumbsInnerFromJSONTyped(json, false)
}

export function ServiceItemBreadcrumbsInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ServiceItemBreadcrumbsInner {
  if (json == null) {
    return json
  }
  return {
    title: json['title'],
    slug: json['slug'],
  }
}

export function ServiceItemBreadcrumbsInnerToJSON(
  value?: ServiceItemBreadcrumbsInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    title: value['title'],
    slug: value['slug'],
  }
}
